<template>
  <div class="c-app" :class="{ 'c-dark-theme': $store.state.darkMode }">
    <TheSidebar/>
    <TheAside/>
    <CWrapper>
      <TheHeader/>
      <div class="c-body">
        <main class="c-main">
          <CContainer fluid>
            <CAlert color="danger" v-if="stamps < 5 && stamps > 0">
              <strong>¡Pocos timbres!</strong> Tienes <strong>{{stamps}}</strong> disponibles, no te quedes sin la posibilidad de facturar y emitir tus complementos de pago, adquiere un paquete de timbres adicionales <a href="/#/my-subscription">aquí</a>.
            </CAlert>
            <CAlert color="danger" v-if="stamps <= 0">
              <strong>¡No tienes timbres!</strong> Tus timbres han sido agotados, no te quedes sin la posibilidad de facturar y emitir tus complementos de pago, adquiere un paquete de timbres adicionales <a href="/#/my-subscription">aquí</a>.
            </CAlert>
            <CAlert color="danger" v-if="deadline < 15 && deadline > 0">
              <strong>¡Timbres por vencer!</strong> Tu paquete de timbres vence el día <strong>{{deadline_date}}</strong>, no te quedes sin la posibilidad de facturar y emitir tus complementos de pago, renueva tu paquete de timbres <a href="/#/my-subscription">aquí</a>.
            </CAlert>
            <CAlert color="danger" v-if="deadline <= 0">
              <strong>¡Timbres vencidos!</strong> Tu paquete de timbres venció el día <strong>{{deadline_date}}</strong>, no te quedes sin la posibilidad de facturar y emitir tus complementos de pago, renueva tu paquete de timbres <a href="/#/my-subscription">aquí</a>.
            </CAlert>
            <transition name="fade" mode="out-in">
              <router-view :key="$route.path"></router-view>
            </transition>
          </CContainer>
        </main>
      </div>
      <TheFooter/>
    </CWrapper>
    <loading :active="visible" :can-cancel="true"></loading>
    <CToaster placement="top-end">
      <template v-for="(toast, key) in toasts">
        <CToast :color="toast.color" v-bind="toast" :key="'toast' + key" :show="true">
          {{toast.content}}
        </CToast>
      </template>
    </CToaster>
  </div>
</template>
<script>
import TheSidebar from './TheSidebar'
import TheHeader from './TheHeader'
import TheFooter from './TheFooter'
import TheAside from './TheAside'
import store from '../store'
import Vue from 'vue';
import Loading from 'vue-loading-overlay/dist/vue-loading.js';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: 'TheContainer',
  components: {
    TheSidebar,
    TheHeader,
    TheFooter,
    TheAside,
    Loading
  },
  data() {
      return {
        
      }
  },
  mounted: async function() {
    
  }, 
  computed: {
    stamps () {
      return store.state.stamps;
    },
    deadline () {
      return store.state.deadline_days;
    },
    deadline_date () {
      return store.state.deadline_date;
    },
    toasts () {
      return store.state.toasts;
    },
    visible() {
      return store.state.isLoading;
    }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
